import { render, staticRenderFns } from "./IndexPatProPieChart.vue?vue&type=template&id=818ad5f6&"
import script from "./IndexPatProPieChart.vue?vue&type=script&lang=js&"
export * from "./IndexPatProPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports